<template>
<span></span>
</template>

<script>
export default {
  name: 'HistoryDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      rawData: null,
      loading: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        if (!val) this.unbind();
        this.$emit('input', val);
      }
    },
    headers() {
      return []
    },
    footers() {
      return {
        'items-per-page-text': this.$t('history.items_per_page')
      }
    },
    items() {
      return Object.keys(this.rawData || {})
        .map(t => parseInt(t))
        .sort((a, b) => b - a)
        .map(t => ({
          time: t,
          timeText: new Date(t).toLocaleString(this.$i18n.locale),
          ...this.rawData[t]
        }));
    },
    columnKeys() {
      let firstItem = Object.values(this.rawData || {}).find(s => s) || {};
      return ['time'].concat(Object.keys(firstItem));
    },
    dataRef() {
      return this.$db.ref(`pieReportHistory/${this.device}/${this.endpoint}`);
    }
  },
  methods: {
    displayHeader(key) {
      return key;
    },
    bind() {
      this.loading = true;
      this.dataRef.limitToLast(50).on('value', snapshot => {
        this.rawData = snapshot.val();
        this.loading = false;
      });
    },
    unbind() {
      this.dataRef.off();
    }
  },
  mounted() {
    this.bind();
  }
}
</script>
